import React from "react";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIRadio from "@mui/material/Radio";
import { extractFormFieldError } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import { useControlSize } from "../formDense";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./radio.module.scss";
function Radio({ size, isRequired = false, isDisabled = false, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const { hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => (React.createElement("div", { className: styles.root },
            React.createElement(MUIFormControlLabel, { label: props.label, disabled: isDisabled, control: React.createElement(MUIRadio, { value: field.value, name: field.name, id: props.id, onChange: (event) => {
                        var _a;
                        field.onChange();
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                    }, onBlur: () => {
                        var _a;
                        field.onBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                    }, color: hasError ? "error" : "default", size: resolvedSize, inputRef: field.ref, required: isRequired, checked: props.isChecked, disabled: isDisabled }) }))) }));
}
export default Radio;
//# sourceMappingURL=Radio.js.map